import _ from 'lodash';

export default class CheckItems {
  constructor(onChange) {
    this.lastClicked = null;
    this.onChange = onChange;
    this.toggleChecked = toggleChecked.bind(this);
    this.toggleAllChecked = toggleAllChecked.bind(this);
  }

  setList(list) {
    this.list = list;
  }

  setOnChange(onChange) {
    this.onChange = onChange;
  }
}


/**
 * toggleChecked is called every time the user clicks on a row. It toggles the
 * state of the checked item. If the user is holding shift and causing an item to
 * become checked, it checks all of the items between the current item and the
 * last item that was clicked. It stores which item was clicked, and updates the
 * items in the store.
 */
function toggleChecked(event, initialItem) {
  if (initialItem.checkboxDisabled) return;

  // Get the item out of the list, because we don't want to mutate a component's props
  const item = _.find(this.list, initialItem);
  const itemIndex = _.indexOf(this.list, item);

  item.checked = !item.checked;

  if (event.shiftKey && item.checked && this.lastClicked !== null) {
    checkAllInRange(this.list, itemIndex, this.lastClicked, true);
  }
  
  this.lastClicked = itemIndex;
  if (!item.checked) this.lastClicked = null;
  
  this.onChange(this.list);
}


/**
 * toggleAllChecked causes all items in the list to become checked or unchecked when
 * the master checkbox is clicked.
 */
function toggleAllChecked() {
  const anyChecked = _.filter(this.list, 'checked').length;

  checkAllInRange(this.list, 0, this.list.length, !anyChecked);
  this.onChange(this.list);
}


/**
 * checkAllInRange checks the checkboxes of all of the items in the list between
 * the item that was just clicked and the last item that was clicked
 */
function checkAllInRange(array, start, end, checked) {
  _.forEach(array, (item, index) => {
    if (_.inRange(index, start, end) && !item.checkboxDisabled) {
      item.checked = checked;
    }
  });
}
